import { render, staticRenderFns } from "./TableSelectItem.vue?vue&type=template&id=18c28a3d&scoped=true"
import script from "./TableSelectItem.vue?vue&type=script&lang=js"
export * from "./TableSelectItem.vue?vue&type=script&lang=js"
import style0 from "./TableSelectItem.vue?vue&type=style&index=0&id=18c28a3d&scoped=true&lang=css"
import style1 from "./TableSelectItem.vue?vue&type=style&index=1&id=18c28a3d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c28a3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c28a3d')) {
      api.createRecord('18c28a3d', component.options)
    } else {
      api.reload('18c28a3d', component.options)
    }
    module.hot.accept("./TableSelectItem.vue?vue&type=template&id=18c28a3d&scoped=true", function () {
      api.rerender('18c28a3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableSelectItem.vue"
export default component.exports